export const PREMIUM_PRODUCTS = {
    premiumReport: {
        id: 'premiumReport',
        paymentProductId: 'mega_premium',
        price: 9900,
        title: 'Premium Report',
        description: 'Unlock the full premium report after completing the Mega test.',
        route: '/premium',
        requirement: {
            testType: 'mega',
            ctaRoute: '/mega-test',
            ctaLabel: 'Take Mega Test',
            missingMessage: 'Complete the Mega test to open this premium report.',
        },
    },
    lovePremium: {
        id: 'lovePremium',
        paymentProductId: 'love_premium',
        price: 9900,
        title: 'Premium Love Report',
        description: 'Unlock the full love analysis after completing the Love test.',
        route: '/premium/love',
        requirement: {
            testType: 'love',
            ctaRoute: '/love-test',
            ctaLabel: 'Take Love Test',
            missingMessage: 'Complete the Love test to open this premium report.',
        },
    },
    chemistryPremium: {
        id: 'chemistryPremium',
        paymentProductId: 'chemistry_premium',
        price: 500,
        title: '케미 프리미엄 리포트',
        description: '이 조합의 끌림 흐름과 추가 해석을 프리미엄으로 확인하세요.',
        route: '/chemistry-test/result',
    },
    beyondPremium: {
        id: 'beyondPremium',
        paymentProductId: 'beyond_premium',
        price: 9900,
        title: 'Premium Beyond Report',
        description: 'Unlock the full beyond analysis after completing the Beyond test.',
        route: '/premium/beyond',
        requirement: {
            testType: 'beyond',
            ctaRoute: '/beyond-test',
            ctaLabel: 'Take Beyond Test',
            missingMessage: 'Complete the Beyond test to open this premium report.',
        },
    },
    insideReport: {
        id: 'insideReport',
        title: 'Inside Report',
        description: 'Generate the combined inner report after completing Mega and Beyond.',
        route: '/inside-report',
        accessMode: 'guest_or_login',
        requirement: {
            testType: 'inside',
            ctaRoute: '/mega-test',
            ctaLabel: 'Take Mega Test',
            secondaryCtaRoute: '/beyond-test',
            secondaryCtaLabel: 'Take Beyond Test',
            missingMessage: 'Complete both Mega and Beyond to open the inside report.',
        },
    },
};

export function getPremiumProduct(productId) {
    return PREMIUM_PRODUCTS[productId] || null;
}
